import { style, types } from 'typestyle';

export { classes } from 'typestyle';

export type Style = types.NestedCSSProperties;

/** Creates a unique classname for the specified styles using TypeStyle */
export function cssClass(prefix: string, name: string, ...styles: Style[]): string {
  return style(...styles, {
    $debugName: `${prefix}_${name}`,
    $unique: true,
  });
}